export default {
    API_BASE: 'https://d1nd2761nfgm51.cloudfront.net/api/mobileKlinik/'
}